/** View modes to display data or entities */
export const DATA_VIEW_MODES = [/** Display the data in cards */
"cards", /** Display the data in a table */
"list", /** Display the data in a map */
"map"];

/** Subject types that support data view modes */
export const DATA_VIEW_MODE_SUBJECTS = ["projects", "groups"];